import { refreshTokenIfNeeded, getStoredTokens } from "./tokenManager";
import { log } from "../../utils/log";

export const checkIfTokenIsNeedingUpdate = async (body: string) => {
  const isQueryValid = !body?.includes('"operationName":"refreshToken"');

  if (!isQueryValid) return null;

  log("Interceptando operação GraphQL para possível atualização de token");
  const renewed = await refreshTokenIfNeeded();
  return renewed ? getStoredTokens()?.token ?? null : null;
};
